import React from 'react'
import t from '~t'
import { Button, ButtonRow, Preloader } from '~ui';

export default function ExtensionTabsAction({ tabs, loading }) {
    if (loading)
        return (
            <ButtonRow>
                <Button variant='ghost'>
                    <Preloader />
                </Button>
            </ButtonRow>
        )

    return (
        <ButtonRow>
            <Button 
                autoFocus
                as='input'
                type='submit'
                variant='primary'
                value={t.format('saveTabsCount', tabs.length)} />
        </ButtonRow>
    )
}